
export default {
  patient: {},
  attachment: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/state.js